import * as yup from 'yup';

export const excludedContainersValidationSchema = yup.object({
  enabled: yup.boolean().required('Enabled is required'),
  containers: yup
    .array()
    .of(yup.string().required('Container name is required'))
    .when('enabled', {
      is: true,
      then: (schema) =>
        schema
          .min(1, 'At least one container name is required when enabled')
          .required(),
    })
    .required(),
});
